import { register } from '@shopify/theme-sections';

register('header', {
    onLoad() {
        // DOM is loaded and ready for manipulation here
        const body = document.body;
        const bodyOverlay = document.getElementsByClassName('body-overlay')[0];
        const breakpoint = 992;

        const headerMenu = document.getElementsByClassName('header__menu')[0];
        const headerLogo = document.getElementsByClassName('header__logo')[0];
        const headerGoBackArrow = document.getElementsByClassName('header__go-back-arrow')[0];
        const hamburgerIcon = document.getElementsByClassName('header__tools-hamburger')[0];

        const searchBar = document.getElementsByClassName('search-bar')[0];
        const searchBarIcon = document.getElementsByClassName('header__tools-search')[0];
        const searchBarCloseIcon = document.getElementsByClassName('search-bar__close')[0];
        const searchBarField = searchBar.getElementsByClassName('search-bar__field')[0];

        const menus = document.getElementsByClassName('header__menu-item-arrow');
        const menuItemLinks = document.getElementsByClassName('header__menu-item-link');
        const menuElem = document.getElementsByClassName('header__menu')[0];
        const submenuList = document.getElementsByClassName('header__dropdown-menu-item-link-wrapper-mobile');
        const dropdowns = document.getElementsByClassName('header__dropdown');

        let i;

        function hideHeaderMenu() {
            body.classList.remove('header-menu--show');
            headerMenu.classList.remove('header__menu--show');
            resetMenu();
        }
        function showHeaderMenu() {
            body.classList.add('header-menu--show');
            headerMenu.classList.add('header__menu--show');
            resetMenu();
        }
        function mouseOverMenu() {
            if (window.innerWidth > 991) {
                body.classList.add('header-menu--show');
            }
        }
        function mouseOutMenu() {
            if (window.innerWidth > 991) {
                body.classList.remove('header-menu--show');
            }
        }
        function resetMenu() {
            headerLogo.classList.remove('header__logo--go-back');
            headerMenu.classList.remove('header__menu--locked');
            for (i = 0; i < dropdowns.length; i++) {
                dropdowns[i].classList.remove('header__dropdown--show');
            }
        }

        function showSearchBar(e) {
            e.preventDefault();
            hideHeaderMenu();

            searchBar.classList.add('search-bar--active');

            //Focus on the search field
            if (searchBarField && searchBar.classList.contains('search-bar--active')) {
                setTimeout(function() {
                    searchBarField.focus();
                }, 300);
            }
            bodyOverlay.classList.add('show');
        }
        function hideSearchBar(e) {
            e.preventDefault();
            searchBarField.blur();
            searchBar.classList.remove('search-bar--active');
            bodyOverlay.classList.remove('show');
        }

        function showSubmenu(e) {
            if (window.innerWidth < breakpoint) {
                e.preventDefault();
                if (menuElem.scrollTo) {
                    menuElem.scrollTo(0, 0);
                } else if (menuElem.scrollByPages) {
                    menuElem.scrollByPages(-2);
                }
                this.parentElement.parentElement
                    .querySelector('.header__dropdown')
                    .classList.add('header__dropdown--show');
                document
                    .querySelector('.header__logo')
                    .classList.add('header__logo--go-back');
                menuElem.classList.add('header__menu--locked');
            }
        }

        //Hamburger
        hamburgerIcon.addEventListener('click', function event(e) {
            if (window.innerWidth < breakpoint) {
                e.preventDefault();
                scrollTo(0, 0);
                if (body.classList.contains('header-menu--show') ) {
                    hideHeaderMenu();
                } else {
                    showHeaderMenu();
                    if (searchBar.classList.contains('search-bar--active')) {
                        hideSearchBar(e);
                    }
                }
            }
        });

        for (i = 0; i < submenuList.length; i++) {
            submenuList[i].addEventListener('click', function event(e) {
                if (window.innerWidth < breakpoint) {
                    e.preventDefault();
                    this.parentElement.classList.toggle('header__dropdown-menu-item--open');
                }
            });
        }

        for (i = 0; i < menuItemLinks.length; i++) {
            menuItemLinks[i].addEventListener('click', showSubmenu);
            menuItemLinks[i].addEventListener('mouseover', mouseOverMenu);
            menuItemLinks[i].addEventListener('mouseout', mouseOutMenu);
        }
        for (i = 0; i < dropdowns.length; i++) {
            dropdowns[i].addEventListener('mouseover', mouseOverMenu);
            dropdowns[i].addEventListener('mouseout', mouseOutMenu);
        }

        for (i = 0; i < menus.length; i++) {
            menus[i].addEventListener('click', showSubmenu);
        }
        

        //Header Menu Go Back
        headerGoBackArrow.addEventListener('click', function event(e) {
            if (window.innerWidth < breakpoint) {
                e.preventDefault();
                headerLogo.classList.remove('header__logo--go-back');
                headerMenu.classList.remove('header__menu--locked');
                for (i = 0; i < dropdowns.length; i++) {
                    dropdowns[i].classList.remove('header__dropdown--show');
                }
            }
        });

        //Search
        if (searchBarIcon && searchBar) {
            searchBarIcon.addEventListener('click', function (e) {
                if (searchBar.classList.contains('search-bar--active')) {
                    hideSearchBar(e);
                } else {
                    showSearchBar(e);
                }

            });
            searchBarCloseIcon.addEventListener('click', function (e) {
                hideSearchBar(e);
            });
        }

        //FAVOURITES
        //Activate favourites on page load
        const favouritesString = localStorage.getItem('favourites');
        if (favouritesString) {
            const favourites = JSON.parse(favouritesString);
            if (favourites.length > 0) {
                const headerHeart = document.getElementById('header-heart');
                const favouritesQuantity = headerHeart.getElementsByClassName(
                    'favourite__quantity'
                )
                    ? headerHeart.getElementsByClassName(
                          'favourite__quantity'
                      )[0]
                    : null;
                if (headerHeart) {
                    headerHeart.classList.add('favourite--added');
                    if (favouritesQuantity) {
                        favouritesQuantity.innerHTML = favourites.length;
                    }
                }
            }
        }

        //Manage favourites change event to change the style of the heart in the header
        window.addEventListener('favourites-change', function(event) {
            const favourites = event.detail.favourites
                ? event.detail.favourites
                : null;
            const headerHeart = document.getElementById('header-heart');
            const quantity = headerHeart.getElementsByClassName(
                'favourite__quantity'
            )
                ? headerHeart.getElementsByClassName('favourite__quantity')[0]
                : null;
            if (favourites && favourites.length > 0) {
                if (headerHeart) {
                    headerHeart.classList.add('favourite--added');
                    if (quantity) {
                        quantity.innerHTML = favourites.length;
                    }
                }
            } else {
                if (headerHeart) {
                    headerHeart.classList.remove('favourite--added');
                    if (quantity) {
                        quantity.innerHTML = 0;
                    }
                }
            }
        });

        //Manage cart change event to change the style of the cart icon in the header
        window.addEventListener('cart-change', function(event) {
            const cartProducts = event.detail.quantity
                ? event.detail.quantity
                : 0;
            const headerCart = document.getElementById('header-cart');
            const cartQuantityElem = headerCart.getElementsByClassName('cart__mini-quantity')
                ? headerCart.getElementsByClassName('cart__mini-quantity')[0]
                : null;
            const origQuantity = parseInt(cartQuantityElem.innerHTML);
            const newQuantity = origQuantity + cartProducts;
            cartQuantityElem.innerHTML = newQuantity;
            if (newQuantity > 0) {
                headerCart.classList.add('cart__mini-active');
            } else {
                headerCart.classList.remove('cart__mini-active');
            }
        });
    }
});
